module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Add/Remove Users")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userSearchText),
      expression: "userSearchText"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "placeholder": "Search for users to add"
    },
    domProps: {
      "value": (_vm.userSearchText)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.userSearchText = $event.target.value
      }, function($event) {
        _vm.getAvailableUsers()
      }]
    }
  })]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    staticClass: "row content-centered",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "box box-info box-solid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAvailableUsers),
      expression: "selectedAvailableUsers"
    }],
    ref: "availablelist",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "size": "10"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedAvailableUsers = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.selectedPermissionUsers = []
      }]
    }
  }, _vm._l((_vm.availableUsers), function(obj) {
    return _c('option', {
      domProps: {
        "value": obj
      }
    }, [_vm._v("\n                " + _vm._s((obj.user || {}).lastName) + ", " + _vm._s((obj.user || {}).firstName) + "\n              ")])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 content-centered"
  }, [_c('div', [_c('a', {
    on: {
      "click": function($event) {
        _vm.addUsers()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-right fa-3x icon-btn icon-btn-primary"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.removeUsers()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left fa-3x icon-btn icon-btn-info"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "box box-primary box-solid"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPermissionUsers),
      expression: "selectedPermissionUsers"
    }],
    ref: "permissionlist",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "size": "10"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedPermissionUsers = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.selectedAvailableUsers = []
      }]
    }
  }, _vm._l((_vm.newPermission.users), function(obj) {
    return _c('option', {
      domProps: {
        "value": obj
      }
    }, [_vm._v("\n                " + _vm._s(obj.user.lastName) + ", " + _vm._s(obj.user.firstName) + "\n              ")])
  }))])])])]), _vm._v(" "), _c('div', [_c('input', {
    staticClass: "form-control",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "disabled": true,
      "placeholder": _vm.userDescription
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row content-centered"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newPermission._id),
      expression: "newPermission._id"
    }],
    staticClass: "py-2 text-center row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": !_vm.dirty
    },
    on: {
      "click": _vm.updatePermissionUsers
    }
  }, [_vm._v("Update Permission Users")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Available Users")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Current Users")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1c1e8f3f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c1e8f3f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/permissions/PermissionUsers.vue
// module id = 2270
// module chunks = 0